import React from 'react';
import Reflux from 'reflux';
import ReactTooltip from 'react-tooltip';
import AppStore from '../AppStore';
import AppActions from '../AppActions';
import RcIf from 'rc-if';

class FollowButton extends Reflux.Component {
    constructor (props) {
        super(props);
        this.state = {
            followed: false,
            itsYou: false
        };
        this.store = AppStore;
    }
    componentDidMount () {
        this.checkIfFollowed();
    }
    checkIfFollowed = () => {
        if (this.state.userData && this.state.userData.following) {
            let index = this.state.userData.following.indexOf(this.props.user._id);
            this.setState({followed: (index >= 0)});
            if (this.state.userData.username === this.props.user.username) {
                this.setState({itsYou: true});
            }
        }
    }
    isMe () {
        return this.state.userLogged && this.state.userData.username === this.props.user.username;
    }
    componentWillReceiveProps () {
        this.checkIfFollowed();
    }
    followUser = () => {
        AppActions.followUser(this.props.user._id);
    }
    unfollowUser = () => {
        AppActions.unfollowUser(this.props.user._id);
    }
    render () {
        return (
          <a className='status-user-suggest'>
            <RcIf if={this.state.followed && !this.isMe()} >
              <img src='/images/icons/siguiendo.svg' data-tip='Dejar de Seguir' data-for='unfollow' onClick={this.unfollowUser} />
              <ReactTooltip place='left' type='dark' effect='solid' id='unfollow' />
            </RcIf>
            <RcIf if={!this.state.followed && !this.isMe()} >
              <img src='/images/icons/seguir.svg' data-tip='Seguir' data-for='follow' onClick={this.followUser} />
              <ReactTooltip place='left' type='dark' effect='solid' id='follow' />
            </RcIf >
          </a>
        );
    };
}

export default FollowButton;



// WEBPACK FOOTER //
// ./src/components/FollowButton.js